import Vue from 'vue';
import validationRules from './validation-rules';

const validationRulesMixin = Vue.extend({
    methods:
    {
        ...validationRules

    }
});

export default validationRulesMixin;
